import React from 'react';
import { useSelector } from 'react-redux';
import { Menu, ProSidebar, SidebarContent } from 'react-pro-sidebar';
import PropTypes from 'prop-types';
import NavSection from '../aisle/NavSection';
import '../style/sidebar.scss';
import menuItems from './menu';
import { Box } from '@material-ui/core';
import AgencyLogo from '../growz/AgencyLogo';

SideBar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function SideBar() {
  const menuCollapsed = useSelector(({ layout }) => layout.menuCollapsed);
  const { user, org } = useSelector(({ auth }) => auth);

  const renderContent = (
    <>
      <Box style={{ padding: '16px 20px 24px 16px', height: '72px' }}>
        <AgencyLogo />
      </Box>

      <div
        style={{
          color: 'rgb(254 254 255 / 60%)',
          fontWeight: '600',
          fontSize: '12px',
          textTransform: 'uppercase',
          margin: '1.5em 30px 8px 20px',
        }}
      >
        MENU
      </div>
      <Menu className={menuCollapsed ? 'collasped_menu_list' : 'expanded_menu_list'}>
        <NavSection navConfig={menuItems} user={Boolean(user.userId)} org={org} open={menuCollapsed} />
      </Menu>
    </>
  );

  return (
    <ProSidebar collapsed={menuCollapsed} className="main-menu">
      <SidebarContent>{renderContent}</SidebarContent>
    </ProSidebar>
  );
}
